module.exports = __webpack_public_path__ + "img/img_banner_01@1x.bbfbed0b.png";